<template>
  <div class="connect">
    <section>
      <div class="mx-auto px-4 py-12 md:container lg:px-12 lg:pb-24 lg:pt-32">
        <h1 class="text-color-1 mb-4 text-center text-3xl font-bold md:text-5xl">Connect</h1>
        <p class="mb-16 text-center">
          The continuous growth is possible through ‘seeking’, never by proving.
        </p>
        <div class="form-wrapper">
          <div class="grid lg:grid-cols-6">
            <div class="lg:col-span-3">
              <div class="image">
                <div
                  class="background-image-wrapper bg-position-top"
                  :style="{
                    backgroundImage: `url('https://public-assets.naamdeo.org/cdn-cgi/image/fit=scale-down,width=1920,quality=75,format=auto/images/ask-naam-deo.jpg')`,
                  }"
                />
              </div>
            </div>
            <div class="lg:col-span-3">
              <div class="px-4 py-8 lg:px-16 lg:py-12">
                <form ref="askNaamDeoForm" @submit.prevent="submitForm">
                  <div class="form-group">
                    <label for="senderName">Name</label>
                    <input
                      id="senderName"
                      v-model="formData.senderName"
                      type="text"
                      name="senderName"
                    />
                  </div>
                  <div class="form-group mt-4">
                    <label for="senderEmail">Email</label>
                    <input
                      id="senderEmail"
                      v-model="formData.senderEmail"
                      type="email"
                      name="senderEmail"
                    />
                  </div>
                  <div class="form-group mt-4">
                    <label for="senderPhone">Phone Number</label>
                    <input
                      id="senderPhone"
                      v-model="formData.senderPhone"
                      type="tel"
                      name="senderPhone"
                    />
                  </div>
                  <div class="form-group mt-4">
                    <label for="senderQuestion"
                      >Ask Naam Deo <sup class="text-color-1">*</sup></label
                    >
                    <textarea
                      id="senderQuestion"
                      v-model="formData.senderQuestion"
                      rows="6"
                      name="senderQuestion"
                    />
                  </div>
                  <input
                    type="submit"
                    :value="isLoading ? 'Sending ...' : 'Send'"
                    class="btn btn-primary mt-12"
                    :disabled="isFormValid"
                  />
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section-bg-1">
      <div class="mx-auto px-4 py-12 md:container lg:px-12 lg:py-24">
        <div>
          <div class="grid gap-8 lg:grid-cols-3">
            <div class="question px-4 py-4 lg:px-8 lg:py-8">
              <h4 class="text-2xl font-bold">Contact:</h4>
              <p class="mt-2"><strong>Name: </strong>Team Naam Deo</p>
              <p class="mt-2">
                <strong>Email: </strong><a href="mailto:info@naamdeo.org">info@naamdeo.org</a>
              </p>
              <p class="mt-2">
                <strong>Phone: </strong><a href="tel:+971 55 571 4269">+971 55 571 4269</a>
              </p>
              <p class="mt-2">
                <strong>Also available on: </strong
                ><button class="link ml-2">
                  <a href="tel:+971 55 571 4269" target="_blank">Skype</a></button
                ><button class="link ml-4">
                  <a href="https://api.whatsapp.com/send?phone=971555714269" target="_blank"
                    >WhatsApp</a
                  >
                </button>
              </p>
            </div>
            <div class="question px-4 py-4 lg:px-8 lg:py-8">
              <h4 class="text-2xl font-bold">For general queries:</h4>
              <p class="mt-4">
                <strong>Email: </strong><a href="mailto:admin@naamdeo.org">admin@naamdeo.org</a>
              </p>
            </div>
            <div class="question px-4 py-4 lg:px-8 lg:py-8">
              <h4 class="text-2xl font-bold">Address:</h4>
              <p class="mt-4">
                Nirmal Road, Nirmal Village, Nalasopara West, Nala Sopara, Mumbai, Maharashtra, Pin
                401304
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import Swal from 'sweetalert2';

const runtimeConfig = useRuntimeConfig();
const isLoading = ref(false);
const formData = ref({
  senderName: '',
  senderEmail: '',
  senderPhone: '',
  senderQuestion: '',
});
const isFormValid = computed(() => {
  return !formData.value.senderQuestion;
});
async function submitForm() {
  isLoading.value = true;
  const response = await fetch(`${runtimeConfig.public.sukritApiUrl}/naamdeo/ask-naamdeo`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    // only add keys to body if they are truthy
    body: JSON.stringify({
      name: formData.value.senderName || undefined,
      email: formData.value.senderEmail || undefined,
      phoneNumber: formData.value.senderPhone || undefined,
      message: formData.value.senderQuestion,
    }),
  });
  if (response.ok) {
    await Swal.fire({
      title: 'Success',
      text: 'Your message has been sent successfully.',
      icon: 'success',
      confirmButtonText: 'Ok',
      confirmButtonColor: '#FC5C04',
    });
    formData.value = {
      senderName: '',
      senderEmail: '',
      senderPhone: '',
      senderQuestion: '',
    };
  } else {
    await Swal.fire({
      title: 'Error',
      text: 'Something went wrong. Please try again later.',
      icon: 'error',
      confirmButtonText: 'Ok',
      confirmButtonColor: '#FC5C04',
    });
  }
  isLoading.value = false;
}

useHead({
  title: 'Connect',
});
</script>

<style lang="scss" scoped>
.connect {
  .form-wrapper {
    border-radius: 10px;
    background-color: #f1f5f5;
    box-shadow: 0px 0px 18px 0px rgba(0, 0, 0, 0.2);
    .image {
      position: relative;
      height: 100%;
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
      overflow: hidden;
      min-height: 350px;
      @media (max-width: 767px),
        (min-device-width: 375px) and (max-device-width: 812px) and (-webkit-min-device-pixel-ratio: 3) and (orientation: portrait) {
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        border-bottom-left-radius: 0;
      }
      .bg-position-top {
        background-position: top !important;
      }
    }
    form {
      .form-group {
        label {
          margin-bottom: 8px;
          display: block;
          font-weight: 500;
        }
        input,
        textarea {
          width: 100%;
          display: block;
          border: 1px solid #bbbbbb;
          border-radius: 4px;
          &:focus {
            outline: none;
          }
          padding: 8px 12px;
        }
        input[type='text'],
        input[type='email'] {
          height: 40px;
          background-color: #fafafa;
        }
        textarea {
          resize: none;
        }
      }
    }
  }
  .question {
    border-radius: 10px;
    background-color: #fefefe;
  }
}
</style>
